
export interface Staff {
  id?: number;
  name: string;
  email?: string;
  phone?: string;
  role?: string; // e.g. BARTENDER, MANAGER, etc.
  barId?: string;
  isActive?: boolean;
  hireDate?: string;
  salary?: number;
  createdAt?: string;
  updatedAt?: string;
  hourlyRate?: number;
  hoursWorked?: number;
  totalTips?: number;
  rating?: number;
  lastActive?: string;
  permissions?: string[];
  /** Set while the person is clocked on; null when off shift. */
  shiftStartedAt?: string | null;
}
